import { createFileRoute } from "@tanstack/react-router";
import { routeHead } from "@/components/seo";
import { pageMeta, services } from "@/content";
import { PlaceholderPage } from "@/components/placeholder-page";

export const Route = createFileRoute("/services/")({
  head: () => routeHead("/services"),
  component: ServicesIndex,
});

function ServicesIndex() {
  const p = pageMeta("/services")!;
  return (
    <PlaceholderPage
      eyebrow="Services"
      heading={p.h1}
      description={p.description}
      items={services.map((s) => ({ label: s.name, href: s.href, summary: s.summary }))}
    />
  );
}
